<div class="permissions-denied">
	<p>
		Para poder continuar se necesita activar los permisos de
		{{ permissionsRequired }}.
	</p>
</div>
